import { Axios, AxiosResponse } from 'axios'
import { RootState } from '@/store'
import { FacilityInfoData } from '@/repositories/commons/corporationInfoRepository'

type PostParamItem = {
  startDate: string;
  endDate: string;
  facilityKeyList: string[];
}

type ResponseHasData = {
  hasCorporationInfo: boolean,
  hasFacilityInfo: boolean,
  hasSettingData: boolean
}

export type FacilityInfoPick = Pick<FacilityInfoData, 'facilityKey' | 'hospitalClinicName'>

export interface KeieiJohoExportRepository {
  checkDataExists (): Promise<ResponseHasData>;
  getFacilityInfoPick (): Promise<FacilityInfoPick[]>;
  export (facilityKeyList: string[]): Promise<AxiosResponse>;
}

export class KeieiJohoExportRepositoryImpl implements KeieiJohoExportRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/keiei-joho/export`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  /**
   * 法人情報と施設情報の存在チェック
   */
  async checkDataExists (): Promise<ResponseHasData> {
    const { data } = await this.http.get(`${this.baseUrl}/check-data-exists`)
    return data
  }

  /**
   * 施設情報のデータ取得
   */
  async getFacilityInfoPick (): Promise<FacilityInfoPick[]> {
    const { data } = await this.http.get(`${this.baseUrl}/facility-info`)
    return data
  }

  /**
   * 出力
   */
  async export (facilityKeyList: string[]): Promise<AxiosResponse> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate
    const postParam: PostParamItem = {
      startDate: startDate,
      endDate: endDate,
      facilityKeyList: facilityKeyList
    }
    return await this.http.post(`${this.baseUrl}/export`, postParam, { responseType: 'blob' })
  }
}
